import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput } from "common-import/custom";
import { inject, observer } from "mobx-react";

import { TimeHelper, VarHelper } from "common-import/helpers"

// @inject("this.store", "userStore") @observer
class List extends Component {

  state = {
    keyword: "",
    page: 1
  }

  store = {};

  messageNotFound = "Hiện chưa có đơn hàng nào đã hoàn thành";

  editMethod = [
    "store",
    "onReady",
    "messageNotFound",
    "getList",
    "renderRow",
    "renderTabletTitle",
    "listData"
  ];

  async componentDidMount() {
    await this.props.userStore.onReady();
    !!this.onReady && this.onReady();
  }

  renderTabletTitle = () => {
    return (
      <tr>
        <th>ID / Money</th>
        <th>Shipping Info</th>
        <th>Cart Info</th>
        <th>Status</th>
        <th>Update At</th>
      </tr>
    );
  }

  renderRow(data, index) {
    const total = (() => {
      let value = 0;
      data.cart.slice().forEach((item, i) => {
        value = value + item.product.price * item.amount;
      });
      return value;
    })();
    return (
      <tr key={"row" + index}>
        <td>
          <Link to={`/order/${data.id}`}>
            <div><strong>{data.id}</strong></div>
            <div>Total: <b style={{ color: 'red' }}>{VarHelper.moneyString(total)}</b></div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div >{data.shipInfo.name}</div>
            <div className="small text-muted">
              <span>Phone</span>: <b>{String(data.shipInfo.phone)}</b>
            </div>
            <div className="small text-muted">
              <span>Email</span>: <b>{String(data.shipInfo.email)}</b>
            </div>
          </div>
        </td>
        <td>
          <a >
            {
              data.cart.map((val, i) => (
                <div className="one-row" key={val.product.name + 'i'} style={{ maxWidth: 300 }}>{val.product.name}</div>
              ))
            }

            {/* <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div> */}
          </a>
        </td>
        <td>
          <div className="small text-muted">{data.status}</div>
        </td>
        <td>
          <div className="small text-muted">{TimeHelper.toDateString(data.updatedAt)}</div>
        </td>
      </tr>

    )
  }

  render() {
    const listApproved = this.listData().slice();
    return (
      <div className="animated fadeIn">
        {/* <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Nhập tên để tìm dự án đã duyệt" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form> */}
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                {this.renderTabletTitle()}
              </thead>
              <tbody style={{ backgroundColor: 'white' }}>
                {listApproved.length > 0 && listApproved.map(this.renderRow)}
              </tbody>
            </Table>
            {listApproved.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>{this.messageNotFound}</p>}
          </Col>
        </Row>
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev} />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { keyword } = this.state;
    if (keyword == "") {
      this.getList();
    } else {
      this.store.search(keyword, true);
    }
  }

  loadPrev = e => {
    !!e && e.preventDefault();
    if (this.state.page === 1) return;
    this.setState({ page: this.state.page - 1 }, () => {
      this.getList(this.state.page);
    });
  }

  loadNext = e => {
    !!e && e.preventDefault();
    this.setState({ page: this.state.page + 1 }, () => {
      this.getList(this.state.page);
    });
  }
}

export default List;


// WEBPACK FOOTER //
// ./src/templates/List.js